import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, XIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { CHECKOUT_URL, PRICE, ANCHOR_PRICE } from '../lib/config';
const rows: {
  without: string;
  with: string;
}[] = [{
  without: 'Improvise every wedding and hope the light waits',
  with: 'Run the script — part by part, minute by minute'
}, {
  without: 'Freeze after five poses',
  with: 'Read the next line. Then the next.'
}, {
  without: 'Start from zero with every couple',
  with: 'Open the volume. Print the page. Done.'
}];
export function Close() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-51" data-mp="1c5h24ebd9iio">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-52" data-mp="17a1rrwcki4r0">
        <h2 className="font-serif text-3xl leading-snug sm:text-5xl sm:leading-tight text-ivory" data-id="element-53" data-mp="129e2bf3zlvyw">
          Stop improvising the one day nobody gets to reshoot.
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-54" data-mp="xcnm8rs6n0dh" />
        <p className="mx-auto mt-8 max-w-2xl text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-55" data-mp="3vdu5vmmmq578">
          Join the photographers who run the day with a script — calm at hour seven, fast on
          formals, home with a gallery that looks directed because it was.
        </p>
        <p className="mt-8 text-[11px] uppercase tracking-[0.2em] text-gold" data-id="element-56" data-mp="3qhdhcrbipotm">
          Getting Ready · First Look · Ceremony · Family Formals · Couple Portraits ·
          Reception — all scripted
        </p>

        <div className="mt-14 overflow-hidden border border-gold/30 text-left" data-id="element-57" data-mp="myahb0wwlayi">
          <div className="grid grid-cols-2" data-id="element-58" data-mp="834awctwba4n">
            <div className="flex items-center gap-2 border-b border-r border-gold/25 px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-ivory/50 sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-59" data-mp="84f9zzcebtpf">
              <XIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-60" data-mp="2suwl7peith9g" />
              Without
            </div>
            <div className="flex items-center gap-2 border-b border-gold/25 px-4 py-3.5 text-[10px] uppercase tracking-[0.16em] text-gold sm:px-6 sm:py-4 sm:text-[11px] sm:tracking-[0.2em]" data-id="element-61" data-mp="148xu3d0hetlz">
              <CheckIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-62" data-mp="zc74nz2selnw" />
              With Direct the Day
            </div>
          </div>
          {rows.map((row, index) => <div key={row.with} className={`grid grid-cols-2 ${index > 0 ? 'border-t border-gold/20' : ''}`} data-id="element-63" data-mp="pjrnh3zbe142" data-mpi={index}>
              <p className="border-r border-gold/20 px-4 py-4 text-[13px] leading-relaxed text-ivory/55 sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-64" data-mp="gj3j70zq3f4d">
                {row.without}
              </p>
              <p className="px-4 py-4 text-[13px] leading-relaxed text-ivory sm:px-6 sm:py-5 sm:text-[15px]" data-id="element-65" data-mp="6lfbzbkxkf5b">
                {row.with}
              </p>
            </div>)}
        </div>

        <p className="mt-16 text-[11px] uppercase tracking-[0.3em] text-gold" data-id="element-66" data-mp="20zga1u8noy4c">
          Launch price ends in
        </p>
        <div className="mt-7" data-id="element-67" data-mp="28jhcaqjdkgfz">
          <Countdown tone="dark" data-id="element-68" data-mp="28ifqps4qgbk0" />
        </div>

        <p className="mt-10 font-serif text-xl text-ivory" data-id="element-69" data-mp="2dhajnmwezghu">
          Direct the Day™ — 6 Volumes + Run of Show + 5 Bonuses
        </p>
        <p className="mt-3 flex items-end justify-center gap-3" data-id="element-70" data-mp="2i9u0csqeerqv">
          <s className="font-serif text-2xl text-ivory/40" data-id="element-71" data-mp="2n8554p1u6c28">{ANCHOR_PRICE}</s>
          <span className="font-serif text-5xl leading-none text-gold" data-id="element-72" data-mp="1pjv4addsducp">{PRICE}</span>
        </p>

        <div className="mt-9" data-id="element-73" data-mp="1uiy9bxtro0ko">
          <CtaButton href={CHECKOUT_URL} data-id="element-74" data-mp="1ui50mrb8z0zw">
            Yes, I want Direct the Day
          </CtaButton>
        </div>

        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.14em] text-ivory/50" data-id="element-75" data-mp="1zh86gdz1xb8x">
          <li className="inline-flex items-center gap-2" data-id="element-76" data-mp="24erlhg3kps1x">
            <LockIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-77" data-mp="3aweo7j7o0lpo" />
            100% secure checkout
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-78" data-mp="3fydtiymytsp9">
            <ZapIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-79" data-mp="3dinrx2n8hjo5" />
            Instant access
          </li>
          <li className="inline-flex items-center gap-2" data-id="element-80" data-mp="39hlpkcy0srhy">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-gold" aria-hidden="true" data-id="element-81" data-mp="3ngbmnskuar6b" />
            30-day guarantee
          </li>
        </ul>
      </div>
    </section>;
}